import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { RedirectCommand, Router } from '@angular/router';
import { MapRoute } from '../common/enums/map-route';
import { SwapModalHelper } from '../common/helpers/swap/swap-modal.helper';

export const swapCardResolver: ResolveFn<void> = (
  route: ActivatedRouteSnapshot,
) => {
  const swapModalHelper = inject(SwapModalHelper);
  const router = inject(Router);

  const uuid = route.paramMap.get('uuid')!;
  swapModalHelper.openModal(uuid, null);

  const urlTree = router.parseUrl(MapRoute.MAP);
  return new RedirectCommand(urlTree, { replaceUrl: true });
};
